/**
 * 3D Visualizer — Cross-Section Profile Registry
 *
 * Each profile defines a closed 2D outline that gets extruded along the
 * board's run length to create real 3D geometry (with grooves, lips,
 * etc. — anything in the cross-section).
 *
 * Profile coordinates (always in feet):
 *   - first axis  = "depth"    — perpendicular to the wall surface; 0 sits
 *                                 at the wall plane, positive extends INTO
 *                                 the room.
 *   - second axis = "vertical" — top-to-bottom of the panel; 0 = panel
 *                                 bottom edge, positive extends upward.
 *
 * The extrusion sweeps the profile along the wall's run direction, so a
 * single profile produces a board of arbitrary length.
 */

import { SLATWALL_PROFILE } from './slatwall';
import { WCB_PROFILE } from './wcb';

export interface CrossSectionProfile {
  id: ProfileId;
  /** Closed polyline of [depth, vertical] points in feet. */
  points: ReadonlyArray<readonly [number, number]>;
  /** Depth extent of the profile (feet). */
  depthSize: number;
  /** Vertical extent of the profile (feet). */
  verticalSize: number;
}

export type ProfileId =
  | 'SlatWall'
  | 'WCB';

const REGISTRY: Record<ProfileId, CrossSectionProfile> = {
  SlatWall: SLATWALL_PROFILE,
  WCB: WCB_PROFILE,
};

export function getProfile(id: ProfileId): CrossSectionProfile {
  return REGISTRY[id];
}
